import { render } from "./ProspectosPage.vue?vue&type=template&id=fca879b4"
import script from "./ProspectosPage.vue?vue&type=script&lang=js"
export * from "./ProspectosPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__